<script setup lang="ts">
const innerValue = defineModel<string | number | boolean>()
</script>
<template>
  <input
    v-model="innerValue"
    type="radio"
    class="size-3.5 border-zinc-200 text-violet-500 checked:border-violet-500 checked:bg-violet-500 focus:ring-violet-500 disabled:bg-zinc-200"
  />
</template>
